export default {"src":"/_next/static/media/audio-light.b7caa94d.svg","height":100,"width":100};